import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { FormFieldPage } from '../form-field/form-field.page';

@Component({
  selector: 'app-form',
  templateUrl: './form.page.html',
  styleUrls: ['./form.page.scss'],
})
export class FormPage implements OnInit {

  constructor(private modalCtrl:ModalController, private navCtrl:NavController) { }

  ngOnInit() {
  }

  async modalForm() {
    const modal = await this.modalCtrl.create({
      component: FormFieldPage,
    });
    return await modal.present();
  }

}
